import { authHeaders } from "@/lib/auth";

const API = process.env.REACT_APP_BACKEND_URL;
const KEY = "fionova_discover_id";

const call = async (path, body, auth = true) => {
  const r = await fetch(`${API}/api/discover${path}`, {
    method: body ? "POST" : "GET",
    headers: { "Content-Type": "application/json", ...(auth ? authHeaders() : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) { const e = new Error(typeof d.detail === "string" ? d.detail : "error"); e.status = r.status; throw e; }
  return d;
};

export const discover = {
  id: () => localStorage.getItem(KEY),
  setId: (v) => localStorage.setItem(KEY, v),
  clear: () => localStorage.removeItem(KEY),
  start: () => call("/start", {}),
  state: (did) => call(`/state/${did}`),
  answer: (did, q, choice) => call("/answer", { discover_id: did, q, choice_index: choice }),
  checkout: (did) => call("/checkout", { discover_id: did }),
  availability: () => fetch(`${process.env.REACT_APP_BACKEND_URL}/api/discover/availability`).then((r) => r.json()).catch(() => ({ checkout_ready: false })),
  verify: (did, sid) => call("/verify", { discover_id: did, session_id: sid }),
  link: (did, sid) => call("/link", { discover_id: did, session_id: sid }),
  results: (did) => call(`/results/${did}`),
};
